import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "pl-4" }
const _hoisted_4 = { class: "flex gap-1 cursor-pointer group mt-2 mb-2" }

import { FormExposition, formInjectionKey } from '@/core/components/forms/Form/form.shared';
import { cloneDeep, set, unset } from 'lodash';
import {
  computed,
  inject,
  ref,
  watch,
  PropType,
} from 'vue';

import { useGetTypeDeviceModel, useGetTypeQuery } from '@/entities/type/hooks';

import {
  Device,
  CreateDeviceData,
  DeviceCreateFormProvider,
} from '@/entities/device/types';

import { NkButton, NkText, NkIcon } from '@/core/components';
import NkDeviceModelChoiceModal from '@/entities/device/components/form/DeviceModelChoiceModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceFormTree',
  props: {
  type: {
    type: Number,
    required: true,
  },
  fields: {
    type: Object as PropType<CreateDeviceData>,
    required: true,
  },
  fieldsPath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



const form = inject(formInjectionKey) as FormExposition;
const validator = computed(() => form?.validator.value);

const getTreeLvlErrors = computed(() => validator.value.$errors.filter(({$propertyPath}) => {
  if ($propertyPath.includes('.deviceValues')) {
    return $propertyPath.split('.deviceValues')[0] === props.fieldsPath;
  }

  return props.fieldsPath === '';
}));

const open = ref(props.fieldsPath === '');
// const hasFetched = ref(false);
const isAddingSubDevice = ref(false);
const isFirstLevel = computed(() => props.fieldsPath === '');

const deviceForm: DeviceCreateFormProvider = (inject('deviceForm') as DeviceCreateFormProvider);
const selectedFieldsPath = computed(() => deviceForm.selectedFieldsPath.value);

const selectedSubDeviceModel = ref(null);

const typeData = computed(() => ({
  id: props.type,
}));

const { data: type } = useGetTypeQuery(typeData);

const enabledToFetch = ref(true);
const isEnabledToFetch = computed(() => !!enabledToFetch.value);

useGetTypeDeviceModel(typeData, {
  enabled: isEnabledToFetch,
  refetchOnWindowFocus: false,
  // eslint-disable-next-line no-use-before-define
  onSuccess: (value) => enabledToFetch.value ? onFetch(value) : false,
});

const subDevices = computed(() => props.fields.subDevices);
const getSubDeviceFieldsPath = (index: number) => [props.fieldsPath, `subDevices.${ index }`].filter(Boolean).join('.');

const selectBranch = () => {
  deviceForm.setSelectedFieldsPath(props.fieldsPath);
};

const handleBranchClick = () => {
  selectBranch();

  if (!isFirstLevel.value) {
    open.value = !open.value;
  }
};

const handleDeletion = (index: number) => {
  // eslint-disable-next-line vue/no-mutating-props
  props.fields.subDevices = props.fields.subDevices.filter((o: Device, _index: number) => index !== _index);

  if (props.fields.subDevices.length) {
    deviceForm.setSelectedFieldsPath(getSubDeviceFieldsPath(props.fields.subDevices.length - 1));
  } else {
    deviceForm.setSelectedFieldsPath(props.fieldsPath);
  }
};

watch(() => selectedSubDeviceModel.value, (v: CreateDeviceData | null) => {
  if (v) {
    const _v = cloneDeep(v);
    // eslint-disable-next-line vue/no-mutating-props
    props.fields.subDevices = [...props.fields.subDevices, _v];
    isAddingSubDevice.value = false;
  } else {
    console.warn(`You can't add more of this subdevice`);
  }
});

const onFetch = (model: CreateDeviceData) => {
  const _model = cloneDeep(model);

  if (_model) {
    Object.keys(props.fields).forEach((key) => unset(props.fields, key));

    Object.entries(_model).forEach(([key, value]) => {
      set(props.fields, key, value);
    });
  }

  if (isFirstLevel.value) {
    selectBranch();
  }

  enabledToFetch.value = false;
};

watch(() => isAddingSubDevice.value, (value) => {
  if (!value) {
    selectedSubDeviceModel.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_DeviceFormTree = _resolveComponent("DeviceFormTree", true)!

  return (_unref(type))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex flex-col", {
      'mt-1': props.fieldsPath !== '',
    }])
      }, [
        _createElementVNode("div", {
          class: "flex items-center gap-2 cursor-pointer relative",
          onClick: _withModifiers(handleBranchClick, ["prevent","stop"])
        }, [
          (_unref(subDevices)?.length)
            ? (_openBlock(), _createBlock(_unref(NkIcon), {
                key: 0,
                size: 3,
                name: "NkArrowBottom",
                class: _normalizeClass(["text-primary transform absolute -translate-x-full -left-2", {'rotate-180': open.value}]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open.value = !open.value), ["prevent","stop"]))
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(NkText), {
            as: "span",
            type: _unref(isFirstLevel) ? 'bold-xxs' : 'semibold-xxs',
            class: _normalizeClass({
            '!text-primary': _unref(selectedFieldsPath) === props.fieldsPath,
          }),
            uppercase: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(type)?.name), 1)
            ]),
            _: 1
          }, 8, ["type", "class"]),
          _renderSlot(_ctx.$slots, "default"),
          (_unref(getTreeLvlErrors).length)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                title: _ctx.$t('device.form.notification.error_badge_title', {n: _unref(getTreeLvlErrors).length}),
                class: "inline-flex h-4 px-2 rounded-lg bg-danger-400 items-center justify-center text-xxs2 text-white"
              }, _toDisplayString(_unref(getTreeLvlErrors).length), 9, _hoisted_2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("div", null, [
            _withDirectives(_createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subDevices) || [], (subDevice, index) => {
                return (_openBlock(), _createBlock(_component_DeviceFormTree, {
                  key: `${subDevice.type}-${index}`,
                  fields: subDevice,
                  type: subDevice.type,
                  "fields-path": getSubDeviceFieldsPath(index)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NkButton), {
                      size: "xxs",
                      icon: "NkMinus",
                      onClick: ($event: any) => (handleDeletion(index)),
                      type: "danger"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["fields", "type", "fields-path"]))
              }), 128))
            ], 512), [
              [_vShow, _unref(subDevices)?.length]
            ]),
            _createVNode(NkDeviceModelChoiceModal, {
              fields: props.fields,
              "type-id": props.type,
              modelValue: selectedSubDeviceModel.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSubDeviceModel).value = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(NkButton), {
                    size: "xxs",
                    icon: "NkPlus"
                  }),
                  _createVNode(_unref(NkText), {
                    type: "light-extra-small",
                    class: "group-hover:text-primary",
                    uppercase: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('device.action.subdevice_add')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["fields", "type-id", "modelValue"])
          ], 512), [
            [_vShow, open.value]
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})